<template>
  <dropdown :value="value"
            :options="options"
            :multiple="multiple"
            :tags="multiple"
            livesearch
            :searching="isSearchingInProgress"
            :placeholder="placeholder"
            @query="onDepartmentSearching"
            @input="onInputChanged">
  </dropdown>
</template>

<script>
  import Dropdown from '@/widgets/dropdown-tree'

  export default {
    name: 'DepartmentSearch',

    props: {
      value: [Array, Object],

      fullSearch: {
        type: Boolean,
        default: false
      },

      multiple: {
        type: Boolean,
        default: false,
      },

      placeholder: String
    },

    components: {
      Dropdown
    },

    data: () => ({
      options: [],
      emptyOptions: [],
      isSearchingInProgress: false
    }),

    async created() {
      this._queryDepartments();
    },

    methods: {
      onInputChanged(data) {
        this.$emit('input', data);
      },

      async _queryDepartments(text) {
        if (!text && this.emptyOptions.length > 0) {
          this.options = this.emptyOptions;
          return;
        }

        try {
          const result = await this.$store.dispatch('searchDepartment', text);

          this.options = (result || []).map(e => ({
            name: e.name,
            id: e.id,
            level: e.level,
            key: e.sortKey,
            expandable: e.expandable,
            collapsed: e.collapsed
          }));
        }
        catch(e) {
          console.error('unable to fetch categories', e)
        }

        if (!text && this.options.length > 0 && this.emptyOptions.length === 0) {
          this.emptyOptions = _.cloneDeep(this.options);
        }
      },

      onDepartmentSearching(text) {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
          this.searchTimer = undefined;
        }

        this.isSearchingInProgress = true;

        this.searchTimer = setTimeout(async () => {
          await this._queryDepartments(text);

          this.searchTimer = undefined;
          this.isSearchingInProgress = false;
        }, 800);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
